module.exports = __webpack_public_path__ + "static/media/coffee.c59b807b.jpg";